[
  {
    "code": "AD",
    "countryCode": 376,
    "names": {
      "de": "Andorra",
      "en": "Andorra",
      "es": "Andorra",
      "fi": "Andorra",
      "fr": "Andorre",
      "it": "Andorra",
      "nl": "Andorra",
      "pt": "Andorra",
      "sv": "Andorra"
    }
  },
  {
    "code": "AE",
    "countryCode": 971,
    "names": {
      "de": "Vereinigte Arabische Emirate",
      "en": "United Arab Emirates",
      "es": "Emiratos Árabes Unidos",
      "fi": "Yhdistyneet arabiemiirikunnat",
      "fr": "Émirats arabes unis",
      "it": "Emirati Arabi Uniti",
      "nl": "Verenigde Arabische Emiraten",
      "pt": "Emirados Árabes Unidos",
      "sv": "Förenade Arabemiraten"
    }
  },
  {
    "code": "AF",
    "countryCode": 93,
    "names": {
      "de": "Afghanistan",
      "en": "Afghanistan",
      "es": "Afganistán",
      "fi": "Afghanistan",
      "fr": "Afghanistan",
      "it": "Afghanistan",
      "nl": "Afghanistan",
      "pt": "Afeganistão",
      "sv": "Afghanistan"
    }
  },
  {
    "code": "AG",
    "countryCode": 1,
    "names": {
      "de": "Antigua und Barbuda",
      "en": "Antigua and Barbuda",
      "es": "Antigua y Barbuda",
      "fi": "Antigua ja Barbuda",
      "fr": "Antigua-et-Barbuda",
      "it": "Antigua e Barbuda",
      "nl": "Antigua en Barbuda",
      "pt": "Antígua e Barbuda",
      "sv": "Antigua och Barbuda"
    }
  },
  {
    "code": "AI",
    "countryCode": 1,
    "names": {
      "de": "Anguilla",
      "en": "Anguilla",
      "es": "Anguila",
      "fi": "Anguilla",
      "fr": "Anguilla",
      "it": "Anguilla",
      "nl": "Anguilla",
      "pt": "Anguilla",
      "sv": "Anguilla"
    }
  },
  {
    "code": "AL",
    "countryCode": 355,
    "names": {
      "de": "Albanien",
      "en": "Albania",
      "es": "Albania",
      "fi": "Albania",
      "fr": "Albanie",
      "it": "Albania",
      "nl": "Albanië",
      "pt": "Albânia",
      "sv": "Albanien"
    }
  },
  {
    "code": "AM",
    "countryCode": 374,
    "names": {
      "de": "Armenien",
      "en": "Armenia",
      "es": "Armenia",
      "fi": "Armenia",
      "fr": "Arménie",
      "it": "Armenia",
      "nl": "Armenië",
      "pt": "Arménia",
      "sv": "Armenien"
    }
  },
  {
    "code": "AO",
    "countryCode": 244,
    "names": {
      "de": "Angola",
      "en": "Angola",
      "es": "Angola",
      "fi": "Angola",
      "fr": "Angola",
      "it": "Angola",
      "nl": "Angola",
      "pt": "Angola",
      "sv": "Angola"
    }
  },
  {
    "code": "AQ",
    "countryCode": 0,
    "names": {
      "de": "Antarktis",
      "en": "Antarctica",
      "es": "Antártida",
      "fi": "Antarktis",
      "fr": "Antarctique",
      "it": "Antartide",
      "nl": "Antarctica",
      "pt": "Antártida",
      "sv": "Antarktis"
    }
  },
  {
    "code": "AR",
    "countryCode": 54,
    "names": {
      "de": "Argentinien",
      "en": "Argentina",
      "es": "Argentina",
      "fi": "Argentiina",
      "fr": "Argentine",
      "it": "Argentina",
      "nl": "Argentinië",
      "pt": "Argentina",
      "sv": "Argentina"
    }
  },
  {
    "code": "AS",
    "countryCode": 1,
    "names": {
      "de": "Amerikanisch-Samoa",
      "en": "American Samoa",
      "es": "Samoa Estadounidense",
      "fi": "Amerikan Samoa",
      "fr": "Samoa américaines",
      "it": "Samoa americane",
      "nl": "Amerikaans Samoa",
      "pt": "Samoa Americana",
      "sv": "Amerikanska Samoa"
    }
  },
  {
    "code": "AT",
    "countryCode": 43,
    "names": {
      "de": "Österreich",
      "en": "Austria",
      "es": "Austria",
      "fi": "Itävalta",
      "fr": "Autriche",
      "it": "Austria",
      "nl": "Oostenrijk",
      "pt": "Áustria",
      "sv": "Österrike"
    }
  },
  {
    "code": "AU",
    "countryCode": 61,
    "names": {
      "de": "Australien",
      "en": "Australia",
      "es": "Australia",
      "fi": "Australia",
      "fr": "Australie",
      "it": "Australia",
      "nl": "Australië",
      "pt": "Austrália",
      "sv": "Australien"
    }
  },
  {
    "code": "AW",
    "countryCode": 297,
    "names": {
      "de": "Aruba",
      "en": "Aruba",
      "es": "Aruba",
      "fi": "Aruba",
      "fr": "Aruba",
      "it": "Aruba",
      "nl": "Aruba",
      "pt": "Aruba",
      "sv": "Aruba"
    }
  },
  {
    "code": "AX",
    "countryCode": 358,
    "names": {
      "de": "Åland",
      "en": "Åland Islands",
      "es": "Islas Äland",
      "fi": "Ahvenanmaa",
      "fr": "Åland",
      "it": "Isole Åland",
      "nl": "Alandeilanden",
      "pt": "Ilhas Alanda",
      "sv": "Åland"
    }
  },
  {
    "code": "AZ",
    "countryCode": 994,
    "names": {
      "de": "Aserbaidschan",
      "en": "Azerbaijan",
      "es": "Azerbaiyán",
      "fi": "Azerbaidžan",
      "fr": "Azerbaïdjan",
      "it": "Azerbaigian",
      "nl": "Azerbeidzjan",
      "pt": "Azerbaijão",
      "sv": "Azerbajdzjan"
    }
  },
  {
    "code": "BA",
    "countryCode": 387,
    "names": {
      "de": "Bosnien und Herzegowina",
      "en": "Bosnia and Herzegovina",
      "es": "Bosnia y Herzegovina",
      "fi": "Bosnia-Hertsegovina",
      "fr": "Bosnie-Herzégovine",
      "it": "Bosnia-Erzegovina",
      "nl": "Bosnië en Herzegovina",
      "pt": "Bósnia e Herzegovina",
      "sv": "Bosnien-Hercegovina"
    }
  },
  {
    "code": "BB",
    "countryCode": 1,
    "names": {
      "de": "Barbados",
      "en": "Barbados",
      "es": "Barbados",
      "fi": "Barbados",
      "fr": "Barbade",
      "it": "Barbados",
      "nl": "Barbados",
      "pt": "Barbados",
      "sv": "Barbados"
    }
  },
  {
    "code": "BD",
    "countryCode": 880,
    "names": {
      "de": "Bangladesch",
      "en": "Bangladesh",
      "es": "Bangladés",
      "fi": "Bangladesh",
      "fr": "Bangladesh",
      "it": "Bangladesh",
      "nl": "Bangladesh",
      "pt": "Bangladeche",
      "sv": "Bangladesh"
    }
  },
  {
    "code": "BE",
    "countryCode": 32,
    "names": {
      "de": "Belgien",
      "en": "Belgium",
      "es": "Bélgica",
      "fi": "Belgia",
      "fr": "Belgique",
      "it": "Belgio",
      "nl": "België",
      "pt": "Bélgica",
      "sv": "Belgien"
    }
  },
  {
    "code": "BF",
    "countryCode": 226,
    "names": {
      "de": "Burkina Faso",
      "en": "Burkina Faso",
      "es": "Burquina Faso",
      "fi": "Burkina Faso",
      "fr": "Burkina Faso",
      "it": "Burkina Faso",
      "nl": "Burkina Faso",
      "pt": "Burkina Faso",
      "sv": "Burkina Faso"
    }
  },
  {
    "code": "BG",
    "countryCode": 359,
    "names": {
      "de": "Bulgarien",
      "en": "Bulgaria",
      "es": "Bulgaria",
      "fi": "Bulgaria",
      "fr": "Bulgarie",
      "it": "Bulgaria",
      "nl": "Bulgarije",
      "pt": "Bulgária",
      "sv": "Bulgarien"
    }
  },
  {
    "code": "BH",
    "countryCode": 973,
    "names": {
      "de": "Bahrain",
      "en": "Bahrain",
      "es": "Baréin",
      "fi": "Bahrain",
      "fr": "Bahreïn",
      "it": "Bahrein",
      "nl": "Bahrein",
      "pt": "Barém",
      "sv": "Bahrain"
    }
  },
  {
    "code": "BI",
    "countryCode": 257,
    "names": {
      "de": "Burundi",
      "en": "Burundi",
      "es": "Burundi",
      "fi": "Burundi",
      "fr": "Burundi",
      "it": "Burundi",
      "nl": "Burundi",
      "pt": "Burundi",
      "sv": "Burundi"
    }
  },
  {
    "code": "BJ",
    "countryCode": 229,
    "names": {
      "de": "Benin",
      "en": "Benin",
      "es": "Benín",
      "fi": "Benin",
      "fr": "Bénin",
      "it": "Benin",
      "nl": "Benin",
      "pt": "Benim",
      "sv": "Benin"
    }
  },
  {
    "code": "BL",
    "countryCode": 590,
    "names": {
      "de": "Saint-Barthélemy",
      "en": "Saint Barthélemy",
      "es": "San Bartolomé",
      "fi": "Saint Barthélemy",
      "fr": "Saint-Barthélemy",
      "it": "Saint-Barthélemy",
      "nl": "Saint Barthélemy",
      "pt": "Saint Barthélemy",
      "sv": "Saint-Barthélemy"
    }
  },
  {
    "code": "BM",
    "countryCode": 1,
    "names": {
      "de": "Bermuda",
      "en": "Bermuda",
      "es": "Islas Bermudas",
      "fi": "Bermuda",
      "fr": "Bermudes",
      "it": "Bermuda",
      "nl": "Bermuda",
      "pt": "Bermudas",
      "sv": "Bermuda"
    }
  },
  {
    "code": "BN",
    "countryCode": 673,
    "names": {
      "de": "Brunei Darussalam",
      "en": "Brunei Darussalam",
      "es": "Brunei Darussalam",
      "fi": "Brunei Darussalamin valtio",
      "fr": "Brunei",
      "it": "Brunei",
      "nl": "Brunei",
      "pt": "Brunei",
      "sv": "Brunei"
    }
  },
  {
    "code": "BO",
    "countryCode": 591,
    "names": {
      "de": "Bolivien",
      "en": "Bolivia, Plurinational State of",
      "es": "Bolivia, Estado plurinacional de",
      "fi": "Bolivia, monikansallinen valtio",
      "fr": "Bolivie",
      "it": "Bolivia, Stato Plurinazionale della",
      "nl": "Bolivia",
      "pt": "Bolívia, Estado Plurinacional da",
      "sv": "Bolivia, Mångnationella staten"
    }
  },
  {
    "code": "BQ",
    "countryCode": 599,
    "names": {
      "de": "Bonaire, Sint Eustatius und Saba",
      "en": "Bonaire, Sint Eustatius and Saba",
      "es": "Islas BES (Caribe Neerlandés)",
      "fi": "Bonaire, Sint Eustatius ja Saba",
      "fr": "Pays-Bas caribéens",
      "it": "Paesi Bassi caraibici",
      "nl": "Bonaire, Sint Eustatius en Saba",
      "pt": "Bonaire, Santo Eustáquio e Saba",
      "sv": "Bonaire, Sint Eustatius och Saba"
    }
  },
  {
    "code": "BR",
    "countryCode": 55,
    "names": {
      "de": "Brasilien",
      "en": "Brazil",
      "es": "Brasil",
      "fi": "Brasilia",
      "fr": "Brésil",
      "it": "Brasile",
      "nl": "Brazilië",
      "pt": "Brasil",
      "sv": "Brasilien"
    }
  },
  {
    "code": "BS",
    "countryCode": 1,
    "names": {
      "de": "Bahamas",
      "en": "Bahamas",
      "es": "Bahamas",
      "fi": "Bahama",
      "fr": "Bahamas",
      "it": "Bahamas",
      "nl": "Bahama’s",
      "pt": "Bahamas",
      "sv": "Bahamas"
    }
  },
  {
    "code": "BT",
    "countryCode": 975,
    "names": {
      "de": "Bhutan",
      "en": "Bhutan",
      "es": "Bután",
      "fi": "Bhutan",
      "fr": "Bhoutan",
      "it": "Bhutan",
      "nl": "Bhutan",
      "pt": "Butão",
      "sv": "Bhutan"
    }
  },
  {
    "code": "BV",
    "countryCode": 0,
    "names": {
      "de": "Bouvetinsel",
      "en": "Bouvet Island",
      "es": "Isla Bouvet",
      "fi": "Bouvet'nsaari",
      "fr": "Île Bouvet",
      "it": "Isola Bouvet",
      "nl": "Bouveteiland",
      "pt": "Ilha Bouvet",
      "sv": "Bouvetön"
    }
  },
  {
    "code": "BW",
    "countryCode": 267,
    "names": {
      "de": "Botswana",
      "en": "Botswana",
      "es": "Botsuana",
      "fi": "Botswana",
      "fr": "Botswana",
      "it": "Botswana",
      "nl": "Botswana",
      "pt": "Botsuana",
      "sv": "Botswana"
    }
  },
  {
    "code": "BY",
    "countryCode": 375,
    "names": {
      "de": "Belarus (Weißrussland)",
      "en": "Belarus",
      "es": "Bielorrusia",
      "fi": "Valko-Venäjä",
      "fr": "Biélorussie",
      "it": "Bielorussia",
      "nl": "Wit-Rusland",
      "pt": "Bielorússia",
      "sv": "Vitryssland"
    }
  },
  {
    "code": "BZ",
    "countryCode": 501,
    "names": {
      "de": "Belize",
      "en": "Belize",
      "es": "Belice",
      "fi": "Belize",
      "fr": "Bélize",
      "it": "Belize",
      "nl": "Belize",
      "pt": "Belize",
      "sv": "Belize"
    }
  },
  {
    "code": "CA",
    "countryCode": 1,
    "names": {
      "de": "Kanada",
      "en": "Canada",
      "es": "Canadá",
      "fi": "Kanada",
      "fr": "Canada",
      "it": "Canada",
      "nl": "Canada",
      "pt": "Canadá",
      "sv": "Kanada"
    }
  },
  {
    "code": "CC",
    "countryCode": 61,
    "names": {
      "de": "Kokosinseln",
      "en": "Cocos (Keeling) Islands",
      "es": "Islas Cocos (Keeling)",
      "fi": "Kookossaaret",
      "fr": "Îles Cocos",
      "it": "Isole Cocos (Keeling)",
      "nl": "Cocoseilanden (Keelingeilanden)",
      "pt": "Ilhas Cocos",
      "sv": "Kokosöarna"
    }
  },
  {
    "code": "CD",
    "countryCode": 243,
    "names": {
      "de": "Kongo, Demokratische Republik (ehem. Zaire)",
      "en": "Congo, The Democratic Republic of the",
      "es": "Congo, República Democrática del",
      "fi": "Kongon demokraattinen tasavalta",
      "fr": "République démocratique du Congo",
      "it": "Repubblica democratica del Congo",
      "nl": "Congo-Kinshasa",
      "pt": "Congo, República Democrática do",
      "sv": "Kongo, demokratiska republiken"
    }
  },
  {
    "code": "CF",
    "countryCode": 236,
    "names": {
      "de": "Zentralafrikanische Republik",
      "en": "Central African Republic",
      "es": "República Centroafricana",
      "fi": "Keski-Afrikan tasavalta",
      "fr": "République centrafricaine",
      "it": "Repubblica Centrafricana",
      "nl": "Centraal-Afrikaanse Republiek",
      "pt": "República Centro-Africana",
      "sv": "Centralafrikanska republiken"
    }
  },
  {
    "code": "CG",
    "countryCode": 242,
    "names": {
      "de": "Republik Kongo",
      "en": "Congo",
      "es": "Congo",
      "fi": "Kongo",
      "fr": "Congo",
      "it": "Congo",
      "nl": "Congo",
      "pt": "Congo",
      "sv": "Kongo"
    }
  },
  {
    "code": "CH",
    "countryCode": 41,
    "names": {
      "de": "Schweiz",
      "en": "Switzerland",
      "es": "Suiza",
      "fi": "Sveitsi",
      "fr": "Suisse",
      "it": "Svizzera",
      "nl": "Zwitserland",
      "pt": "Suíça",
      "sv": "Schweiz"
    }
  },
  {
    "code": "CI",
    "countryCode": 225,
    "names": {
      "de": "Côte d'Ivoire (Elfenbeinküste)",
      "en": "Côte d'Ivoire",
      "es": "Costa de Marfíl",
      "fi": "Norsunluurannikko",
      "fr": "Côte d'Ivoire",
      "it": "Costa d'Avorio",
      "nl": "Ivoorkust",
      "pt": "Costa do Marfim",
      "sv": "Elfenbenskusten"
    }
  },
  {
    "code": "CK",
    "countryCode": 682,
    "names": {
      "de": "Cookinseln",
      "en": "Cook Islands",
      "es": "Islas Cook",
      "fi": "Cookinsaaret",
      "fr": "Îles Cook",
      "it": "Isole Cook",
      "nl": "Cookeilanden",
      "pt": "Ilhas Cook",
      "sv": "Cooköarna"
    }
  },
  {
    "code": "CL",
    "countryCode": 56,
    "names": {
      "de": "Chile",
      "en": "Chile",
      "es": "Chile",
      "fi": "Chile",
      "fr": "Chili",
      "it": "Cile",
      "nl": "Chili",
      "pt": "Chile",
      "sv": "Chile"
    }
  },
  {
    "code": "CM",
    "countryCode": 237,
    "names": {
      "de": "Kamerun",
      "en": "Cameroon",
      "es": "Camerún",
      "fi": "Kamerun",
      "fr": "Cameroun",
      "it": "Camerun",
      "nl": "Kameroen",
      "pt": "Camarões",
      "sv": "Kamerun"
    }
  },
  {
    "code": "CN",
    "countryCode": 86,
    "names": {
      "de": "China, Volksrepublik",
      "en": "China",
      "es": "China",
      "fi": "Kiina",
      "fr": "Chine",
      "it": "Cina",
      "nl": "China",
      "pt": "China",
      "sv": "Kina"
    }
  },
  {
    "code": "CO",
    "countryCode": 57,
    "names": {
      "de": "Kolumbien",
      "en": "Colombia",
      "es": "Colombia",
      "fi": "Kolumbia",
      "fr": "Colombie",
      "it": "Colombia",
      "nl": "Colombia",
      "pt": "Colômbia",
      "sv": "Colombia"
    }
  },
  {
    "code": "CR",
    "countryCode": 506,
    "names": {
      "de": "Costa Rica",
      "en": "Costa Rica",
      "es": "Costa Rica",
      "fi": "Costa Rica",
      "fr": "Costa Rica",
      "it": "Costa Rica",
      "nl": "Costa Rica",
      "pt": "Costa Rica",
      "sv": "Costa Rica"
    }
  },
  {
    "code": "CU",
    "countryCode": 53,
    "names": {
      "de": "Kuba",
      "en": "Cuba",
      "es": "Cuba",
      "fi": "Kuuba",
      "fr": "Cuba",
      "it": "Cuba",
      "nl": "Cuba",
      "pt": "Cuba",
      "sv": "Kuba"
    }
  },
  {
    "code": "CV",
    "countryCode": 238,
    "names": {
      "de": "Kap Verde",
      "en": "Cabo Verde",
      "es": "Cabo Verde",
      "fi": "Kap Verde",
      "fr": "Cap-Vert",
      "it": "Capo Verde",
      "nl": "Kaapverdië",
      "pt": "Cabo Verde",
      "sv": "Kap Verde"
    }
  },
  {
    "code": "CW",
    "countryCode": 599,
    "names": {
      "de": "Curaçao",
      "en": "Curaçao",
      "es": "Curazao",
      "fi": "Curaçao",
      "fr": "Curaçao",
      "it": "Curaçao",
      "nl": "Curaçao",
      "pt": "Curação",
      "sv": "Curaçao"
    }
  },
  {
    "code": "CX",
    "countryCode": 61,
    "names": {
      "de": "Weihnachtsinsel",
      "en": "Christmas Island",
      "es": "Isla de Navidad",
      "fi": "Joulusaari",
      "fr": "Île Christmas (Australie)",
      "it": "Isola di Natale",
      "nl": "Christmaseiland",
      "pt": "Ilha Natal",
      "sv": "Julön"
    }
  },
  {
    "code": "CY",
    "countryCode": 357,
    "names": {
      "de": "Zypern",
      "en": "Cyprus",
      "es": "Chipre",
      "fi": "Kypros",
      "fr": "Chypre",
      "it": "Cipro",
      "nl": "Cyprus",
      "pt": "Chipre",
      "sv": "Cypern"
    }
  },
  {
    "code": "CZ",
    "countryCode": 420,
    "names": {
      "de": "Tschechien",
      "en": "Czechia",
      "es": "Chequia",
      "fi": "Czechia",
      "fr": "Tchéquie",
      "it": "Cechia",
      "nl": "Tsjechië",
      "pt": "Chéquia",
      "sv": "Tjeckien"
    }
  },
  {
    "code": "DE",
    "countryCode": 49,
    "names": {
      "de": "Deutschland",
      "en": "Germany",
      "es": "Alemania",
      "fi": "Saksa",
      "fr": "Allemagne",
      "it": "Germania",
      "nl": "Duitsland",
      "pt": "Alemanha",
      "sv": "Tyskland"
    }
  },
  {
    "code": "DJ",
    "countryCode": 253,
    "names": {
      "de": "Dschibuti",
      "en": "Djibouti",
      "es": "Yibuti",
      "fi": "Djibouti",
      "fr": "Djibouti",
      "it": "Gibuti",
      "nl": "Djibouti",
      "pt": "Djibouti",
      "sv": "Djibouti"
    }
  },
  {
    "code": "DK",
    "countryCode": 45,
    "names": {
      "de": "Dänemark",
      "en": "Denmark",
      "es": "Dinamarca",
      "fi": "Tanska",
      "fr": "Danemark",
      "it": "Danimarca",
      "nl": "Denemarken",
      "pt": "Dinamarca",
      "sv": "Danmark"
    }
  },
  {
    "code": "DM",
    "countryCode": 1,
    "names": {
      "de": "Dominica",
      "en": "Dominica",
      "es": "Dominica",
      "fi": "Dominica",
      "fr": "Dominique",
      "it": "Dominica",
      "nl": "Dominica",
      "pt": "Dominica",
      "sv": "Dominica"
    }
  },
  {
    "code": "DO",
    "countryCode": 1,
    "names": {
      "de": "Dominikanische Republik",
      "en": "Dominican Republic",
      "es": "República Dominicana",
      "fi": "Dominikaaninen tasavalta",
      "fr": "République dominicaine",
      "it": "Repubblica Dominicana",
      "nl": "Dominicaanse Republiek",
      "pt": "República Dominicana",
      "sv": "Dominikanska republiken"
    }
  },
  {
    "code": "DZ",
    "countryCode": 213,
    "names": {
      "de": "Algerien",
      "en": "Algeria",
      "es": "Algeria",
      "fi": "Algeria",
      "fr": "Algérie",
      "it": "Algeria",
      "nl": "Algerije",
      "pt": "Argélia",
      "sv": "Algeriet"
    }
  },
  {
    "code": "EC",
    "countryCode": 593,
    "names": {
      "de": "Ecuador",
      "en": "Ecuador",
      "es": "Ecuador",
      "fi": "Ecuador",
      "fr": "Équateur",
      "it": "Ecuador",
      "nl": "Ecuador",
      "pt": "Equador",
      "sv": "Ecuador"
    }
  },
  {
    "code": "EE",
    "countryCode": 372,
    "names": {
      "de": "Estland",
      "en": "Estonia",
      "es": "Estonia",
      "fi": "Viro",
      "fr": "Estonie",
      "it": "Estonia",
      "nl": "Estland",
      "pt": "Estónia",
      "sv": "Estland"
    }
  },
  {
    "code": "EG",
    "countryCode": 20,
    "names": {
      "de": "Ägypten",
      "en": "Egypt",
      "es": "Egipto",
      "fi": "Egypti",
      "fr": "Égypte",
      "it": "Egitto",
      "nl": "Egypte",
      "pt": "Egito",
      "sv": "Egypten"
    }
  },
  {
    "code": "EH",
    "countryCode": 212,
    "names": {
      "de": "Westsahara",
      "en": "Western Sahara",
      "es": "Sahara Occidental",
      "fi": "Länsi-Sahara",
      "fr": "Sahara occidental",
      "it": "Sahara occidentale",
      "nl": "Westelijke Sahara",
      "pt": "Saara Ocidental",
      "sv": "Västsahara"
    }
  },
  {
    "code": "ER",
    "countryCode": 291,
    "names": {
      "de": "Eritrea",
      "en": "Eritrea",
      "es": "Eritrea",
      "fi": "Eritrea",
      "fr": "Érythrée",
      "it": "Eritrea",
      "nl": "Eritrea",
      "pt": "Eritreia",
      "sv": "Eritrea"
    }
  },
  {
    "code": "ES",
    "countryCode": 34,
    "names": {
      "de": "Spanien",
      "en": "Spain",
      "es": "España",
      "fi": "Espanja",
      "fr": "Espagne",
      "it": "Spagna",
      "nl": "Spanje",
      "pt": "Espanha",
      "sv": "Spanien"
    }
  },
  {
    "code": "ET",
    "countryCode": 251,
    "names": {
      "de": "Äthiopien",
      "en": "Ethiopia",
      "es": "Etiopía",
      "fi": "Etiopia",
      "fr": "Éthiopie",
      "it": "Etiopia",
      "nl": "Ethiopië",
      "pt": "Etiópia",
      "sv": "Etiopien"
    }
  },
  {
    "code": "FI",
    "countryCode": 358,
    "names": {
      "de": "Finnland",
      "en": "Finland",
      "es": "Finlandia",
      "fi": "Suomi",
      "fr": "Finlande",
      "it": "Finlandia",
      "nl": "Finland",
      "pt": "Finlândia",
      "sv": "Finland"
    }
  },
  {
    "code": "FJ",
    "countryCode": 679,
    "names": {
      "de": "Fidschi",
      "en": "Fiji",
      "es": "Fiyi",
      "fi": "Fidži",
      "fr": "Fidji",
      "it": "Figi",
      "nl": "Fiji",
      "pt": "Fiji",
      "sv": "Fiji"
    }
  },
  {
    "code": "FK",
    "countryCode": 500,
    "names": {
      "de": "Falklandinseln",
      "en": "Falkland Islands (Malvinas)",
      "es": "Islas Falkland (Malvinas)",
      "fi": "Falklandinsaaret",
      "fr": "Îles Malouines",
      "it": "Isole Falkland (Malvine)",
      "nl": "Falklandeilanden (Malvinas)",
      "pt": "Ilhas Falkland (Malvinas)",
      "sv": "Falklandsöarna (Malvinas)"
    }
  },
  {
    "code": "FM",
    "countryCode": 691,
    "names": {
      "de": "Mikronesien",
      "en": "Micronesia, Federated States of",
      "es": "Micronesia, Estados Federados de",
      "fi": "Mikronesian liittovaltio",
      "fr": "Micronésie",
      "it": "Micronesia",
      "nl": "Micronesië",
      "pt": "Micronésia, Estados Federados da",
      "sv": "Mikronesien, federala staterna"
    }
  },
  {
    "code": "FO",
    "countryCode": 298,
    "names": {
      "de": "Färöer",
      "en": "Faroe Islands",
      "es": "Islas Feroe",
      "fi": "Färsaaret",
      "fr": "Îles Féroé",
      "it": "Isole Fær Øer",
      "nl": "Faeröer",
      "pt": "Ilhas Faroé",
      "sv": "Färöarna"
    }
  },
  {
    "code": "FR",
    "countryCode": 33,
    "names": {
      "de": "Frankreich",
      "en": "France",
      "es": "Francia",
      "fi": "Ranska",
      "fr": "France",
      "it": "Francia",
      "nl": "Frankrijk",
      "pt": "França",
      "sv": "Frankrike"
    }
  },
  {
    "code": "GA",
    "countryCode": 241,
    "names": {
      "de": "Gabun",
      "en": "Gabon",
      "es": "Gabón",
      "fi": "Gabon",
      "fr": "Gabon",
      "it": "Gabon",
      "nl": "Gabon",
      "pt": "Gabão",
      "sv": "Gabon"
    }
  },
  {
    "code": "GB",
    "countryCode": 44,
    "names": {
      "de": "Vereinigtes Königreich",
      "en": "United Kingdom",
      "es": "Reino Unido",
      "fi": "Yhdistynyt kuningaskunta",
      "fr": "Royaume-Uni",
      "it": "Regno Unito",
      "nl": "Verenigd Koninkrijk",
      "pt": "Reino Unido",
      "sv": "Förenade kungariket"
    }
  },
  {
    "code": "GD",
    "countryCode": 1,
    "names": {
      "de": "Grenada",
      "en": "Grenada",
      "es": "Granada",
      "fi": "Grenada",
      "fr": "Grenade",
      "it": "Grenada",
      "nl": "Grenada",
      "pt": "Granada",
      "sv": "Grenada"
    }
  },
  {
    "code": "GE",
    "countryCode": 995,
    "names": {
      "de": "Georgien",
      "en": "Georgia",
      "es": "Georgia",
      "fi": "Georgia",
      "fr": "Géorgie",
      "it": "Georgia",
      "nl": "Georgië",
      "pt": "Geórgia",
      "sv": "Georgien"
    }
  },
  {
    "code": "GF",
    "countryCode": 594,
    "names": {
      "de": "Französisch-Guayana",
      "en": "French Guiana",
      "es": "Guayana Francesa",
      "fi": "Ranskan Guayana",
      "fr": "Guyane",
      "it": "Guyana francese",
      "nl": "Frans-Guyana",
      "pt": "Guiana Francesa",
      "sv": "Franska Guyana"
    }
  },
  {
    "code": "GG",
    "countryCode": 44,
    "names": {
      "de": "Guernsey (Kanalinsel)",
      "en": "Guernsey",
      "es": "Guernsey",
      "fi": "Guernsey",
      "fr": "Guernesey",
      "it": "Guernsey",
      "nl": "Guernsey",
      "pt": "Guernsey",
      "sv": "Guernsey"
    }
  },
  {
    "code": "GH",
    "countryCode": 233,
    "names": {
      "de": "Ghana",
      "en": "Ghana",
      "es": "Ghana",
      "fi": "Ghana",
      "fr": "Ghana",
      "it": "Ghana",
      "nl": "Ghana",
      "pt": "Gana",
      "sv": "Ghana"
    }
  },
  {
    "code": "GI",
    "countryCode": 350,
    "names": {
      "de": "Gibraltar",
      "en": "Gibraltar",
      "es": "Gibraltar",
      "fi": "Gibraltar",
      "fr": "Gibraltar",
      "it": "Gibilterra",
      "nl": "Gibraltar",
      "pt": "Gibraltar",
      "sv": "Gibraltar"
    }
  },
  {
    "code": "GL",
    "countryCode": 299,
    "names": {
      "de": "Grönland",
      "en": "Greenland",
      "es": "Groenlandia",
      "fi": "Grönlanti",
      "fr": "Groenland",
      "it": "Groenlandia",
      "nl": "Groenland",
      "pt": "Gronelândia",
      "sv": "Grönland"
    }
  },
  {
    "code": "GM",
    "countryCode": 220,
    "names": {
      "de": "Gambia",
      "en": "Gambia",
      "es": "Gambia",
      "fi": "Gambia",
      "fr": "Gambie",
      "it": "Gambia",
      "nl": "Gambia",
      "pt": "Gâmbia",
      "sv": "Gambia"
    }
  },
  {
    "code": "GN",
    "countryCode": 224,
    "names": {
      "de": "Guinea",
      "en": "Guinea",
      "es": "Guinea",
      "fi": "Guinea",
      "fr": "Guinée",
      "it": "Guinea",
      "nl": "Guinee",
      "pt": "Guiné",
      "sv": "Guinea"
    }
  },
  {
    "code": "GP",
    "countryCode": 590,
    "names": {
      "de": "Guadeloupe",
      "en": "Guadeloupe",
      "es": "Guadalupe",
      "fi": "Guadeloupe",
      "fr": "Guadeloupe",
      "it": "Guadalupa",
      "nl": "Guadeloupe",
      "pt": "Guadalupe",
      "sv": "Guadeloupe"
    }
  },
  {
    "code": "GQ",
    "countryCode": 240,
    "names": {
      "de": "Äquatorialguinea",
      "en": "Equatorial Guinea",
      "es": "Guinea Ecuatorial",
      "fi": "Päiväntasaajan Guinea",
      "fr": "Guinée équatoriale",
      "it": "Guinea equatoriale",
      "nl": "Equatoriaal-Guinea",
      "pt": "Guiné Equatorial",
      "sv": "Ekvatorialguinea"
    }
  },
  {
    "code": "GR",
    "countryCode": 30,
    "names": {
      "de": "Griechenland",
      "en": "Greece",
      "es": "Grecia",
      "fi": "Kreikka",
      "fr": "Grèce",
      "it": "Grecia",
      "nl": "Griekenland",
      "pt": "Grécia",
      "sv": "Grekland"
    }
  },
  {
    "code": "GS",
    "countryCode": 0,
    "names": {
      "de": "Südgeorgien und die Südlichen Sandwichinseln",
      "en": "South Georgia and the South Sandwich Islands",
      "es": "Islas Georgias del Sur y Sándwich del Sur",
      "fi": "Etelä-Georgia ja Eteläiset Sandwichinsaaret",
      "fr": "Géorgie du Sud-et-les Îles Sandwich du Sud",
      "it": "Georgia del Sud e Isole Sandwich Australi",
      "nl": "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      "pt": "Ilhas Geórgia do Sul e Sandwich do Sul",
      "sv": "Sydgeorgien och södra Sandwichöarna"
    }
  },
  {
    "code": "GT",
    "countryCode": 502,
    "names": {
      "de": "Guatemala",
      "en": "Guatemala",
      "es": "Guatemala",
      "fi": "Guatemala",
      "fr": "Guatemala",
      "it": "Guatemala",
      "nl": "Guatemala",
      "pt": "Guatemala",
      "sv": "Guatemala"
    }
  },
  {
    "code": "GU",
    "countryCode": 1,
    "names": {
      "de": "Guam",
      "en": "Guam",
      "es": "Guam",
      "fi": "Guam",
      "fr": "Guam",
      "it": "Guam",
      "nl": "Guam",
      "pt": "Guam",
      "sv": "Guam"
    }
  },
  {
    "code": "GW",
    "countryCode": 245,
    "names": {
      "de": "Guinea-Bissau",
      "en": "Guinea-Bissau",
      "es": "Guinea-Bisáu",
      "fi": "Guinea-Bissau",
      "fr": "Guinée-Bissau",
      "it": "Guinea-Bissau",
      "nl": "Guinee-Bissau",
      "pt": "Guiné-Bissáu",
      "sv": "Guinea-Bissau"
    }
  },
  {
    "code": "GY",
    "countryCode": 592,
    "names": {
      "de": "Guyana",
      "en": "Guyana",
      "es": "Guyana",
      "fi": "Guyana",
      "fr": "Guyana",
      "it": "Guyana",
      "nl": "Guyana",
      "pt": "Guiana",
      "sv": "Guyana"
    }
  },
  {
    "code": "HK",
    "countryCode": 852,
    "names": {
      "de": "Hongkong",
      "en": "Hong Kong",
      "es": "Hong Kong",
      "fi": "Hong Kong",
      "fr": "Hong Kong",
      "it": "Hong Kong",
      "nl": "Hongkong",
      "pt": "Hong Kong",
      "sv": "Hongkong"
    }
  },
  {
    "code": "HM",
    "countryCode": 0,
    "names": {
      "de": "Heard und McDonaldinseln",
      "en": "Heard Island and McDonald Islands",
      "es": "Isla Heard e Islas McDonald",
      "fi": "Heard ja McDonaldinsaaret",
      "fr": "Îles Heard-et-MacDonald",
      "it": "Isole Heard e McDonald",
      "nl": "Heard- en McDonaldeilanden",
      "pt": "Ilha Heard e Ilhas McDonald",
      "sv": "Heardön och McDonaldöarna"
    }
  },
  {
    "code": "HN",
    "countryCode": 504,
    "names": {
      "de": "Honduras",
      "en": "Honduras",
      "es": "Honduras",
      "fi": "Honduras",
      "fr": "Honduras",
      "it": "Honduras",
      "nl": "Honduras",
      "pt": "Honduras",
      "sv": "Honduras"
    }
  },
  {
    "code": "HR",
    "countryCode": 385,
    "names": {
      "de": "Kroatien",
      "en": "Croatia",
      "es": "Croacia",
      "fi": "Kroatia",
      "fr": "Croatie",
      "it": "Croazia",
      "nl": "Kroatië",
      "pt": "Croácia",
      "sv": "Kroatien"
    }
  },
  {
    "code": "HT",
    "countryCode": 509,
    "names": {
      "de": "Haiti",
      "en": "Haiti",
      "es": "Haití",
      "fi": "Haiti",
      "fr": "Haïti",
      "it": "Haiti",
      "nl": "Haïti",
      "pt": "Haiti",
      "sv": "Haiti"
    }
  },
  {
    "code": "HU",
    "countryCode": 36,
    "names": {
      "de": "Ungarn",
      "en": "Hungary",
      "es": "Hungría",
      "fi": "Unkari",
      "fr": "Hongrie",
      "it": "Ungheria",
      "nl": "Hongarije",
      "pt": "Hungria",
      "sv": "Ungern"
    }
  },
  {
    "code": "ID",
    "countryCode": 62,
    "names": {
      "de": "Indonesien",
      "en": "Indonesia",
      "es": "Indonesia",
      "fi": "Indonesia",
      "fr": "Indonésie",
      "it": "Indonesia",
      "nl": "Indonesië",
      "pt": "Indonésia",
      "sv": "Indonesien"
    }
  },
  {
    "code": "IE",
    "countryCode": 353,
    "names": {
      "de": "Irland",
      "en": "Ireland",
      "es": "Irlanda",
      "fi": "Irlanti",
      "fr": "Irlande",
      "it": "Irlanda",
      "nl": "Ierland",
      "pt": "Irlanda",
      "sv": "Irland"
    }
  },
  {
    "code": "IL",
    "countryCode": 972,
    "names": {
      "de": "Israel",
      "en": "Israel",
      "es": "Israel",
      "fi": "Israel",
      "fr": "Israël",
      "it": "Israele",
      "nl": "Israël",
      "pt": "Israel",
      "sv": "Israel"
    }
  },
  {
    "code": "IM",
    "countryCode": 44,
    "names": {
      "de": "Insel Man",
      "en": "Isle of Man",
      "es": "Isla de Man",
      "fi": "Mansaari",
      "fr": "Île de Man",
      "it": "Isola di Man",
      "nl": "Isle of Man",
      "pt": "Ilha de Man",
      "sv": "Isle of Man"
    }
  },
  {
    "code": "IN",
    "countryCode": 91,
    "names": {
      "de": "Indien",
      "en": "India",
      "es": "India",
      "fi": "Intia",
      "fr": "Inde",
      "it": "India",
      "nl": "India",
      "pt": "Índia",
      "sv": "Indien"
    }
  },
  {
    "code": "IO",
    "countryCode": 246,
    "names": {
      "de": "Britisches Territorium im Indischen Ozean",
      "en": "British Indian Ocean Territory",
      "es": "Territorio Británico del Océano Índico",
      "fi": "Brittiläinen Intian valtameren alue",
      "fr": "Territoire britannique de l'océan Indien",
      "it": "Territorio britannico dell'Oceano Indiano",
      "nl": "Britse Gebieden in de Indische Oceaan",
      "pt": "Território Britânico do Oceano Índico",
      "sv": "Brittiskt territorium i Indiska Oceanen"
    }
  },
  {
    "code": "IQ",
    "countryCode": 964,
    "names": {
      "de": "Irak",
      "en": "Iraq",
      "es": "Irak",
      "fi": "Irak",
      "fr": "Irak",
      "it": "Iraq",
      "nl": "Irak",
      "pt": "Iraque",
      "sv": "Irak"
    }
  },
  {
    "code": "IR",
    "countryCode": 98,
    "names": {
      "de": "Iran, Islamische Republik",
      "en": "Iran, Islamic Republic of",
      "es": "Irán, República islámica de",
      "fi": "Iranin islamilainen tasavalta",
      "fr": "Iran",
      "it": "Iran",
      "nl": "Iran",
      "pt": "Irão, República Islâmica do",
      "sv": "Iran, islamiska republiken"
    }
  },
  {
    "code": "IS",
    "countryCode": 354,
    "names": {
      "de": "Island",
      "en": "Iceland",
      "es": "Islandia",
      "fi": "Islanti",
      "fr": "Islande",
      "it": "Islanda",
      "nl": "IJsland",
      "pt": "Islândia",
      "sv": "Island"
    }
  },
  {
    "code": "IT",
    "countryCode": 39,
    "names": {
      "de": "Italien",
      "en": "Italy",
      "es": "Italia",
      "fi": "Italia",
      "fr": "Italie",
      "it": "Italia",
      "nl": "Italië",
      "pt": "Itália",
      "sv": "Italien"
    }
  },
  {
    "code": "JE",
    "countryCode": 44,
    "names": {
      "de": "Jersey (Kanalinsel)",
      "en": "Jersey",
      "es": "Jersey",
      "fi": "Jersey",
      "fr": "Jersey",
      "it": "Jersey",
      "nl": "Jersey",
      "pt": "Jersey",
      "sv": "Jersey"
    }
  },
  {
    "code": "JM",
    "countryCode": 1,
    "names": {
      "de": "Jamaika",
      "en": "Jamaica",
      "es": "Jamaica",
      "fi": "Jamaika",
      "fr": "Jamaïque",
      "it": "Giamaica",
      "nl": "Jamaica",
      "pt": "Jamaica",
      "sv": "Jamaica"
    }
  },
  {
    "code": "JO",
    "countryCode": 962,
    "names": {
      "de": "Jordanien",
      "en": "Jordan",
      "es": "Jordania",
      "fi": "Jordania",
      "fr": "Jordanie",
      "it": "Giordania",
      "nl": "Jordanië",
      "pt": "Jordânia",
      "sv": "Jordanien"
    }
  },
  {
    "code": "JP",
    "countryCode": 81,
    "names": {
      "de": "Japan",
      "en": "Japan",
      "es": "Japón",
      "fi": "Japani",
      "fr": "Japon",
      "it": "Giappone",
      "nl": "Japan",
      "pt": "Japão",
      "sv": "Japan"
    }
  },
  {
    "code": "KE",
    "countryCode": 254,
    "names": {
      "de": "Kenia",
      "en": "Kenya",
      "es": "Kenia",
      "fi": "Kenia",
      "fr": "Kenya",
      "it": "Kenya",
      "nl": "Kenia",
      "pt": "Quénia",
      "sv": "Kenya"
    }
  },
  {
    "code": "KG",
    "countryCode": 996,
    "names": {
      "de": "Kirgisistan",
      "en": "Kyrgyzstan",
      "es": "Kirguistán",
      "fi": "Kirgisia",
      "fr": "Kirghizistan",
      "it": "Kirghizistan",
      "nl": "Kirgizië",
      "pt": "Quirguistão",
      "sv": "Kirgizistan"
    }
  },
  {
    "code": "KH",
    "countryCode": 855,
    "names": {
      "de": "Kambodscha",
      "en": "Cambodia",
      "es": "Camboya",
      "fi": "Kambodža",
      "fr": "Cambodge",
      "it": "Cambogia",
      "nl": "Cambodja",
      "pt": "Camboja",
      "sv": "Kambodja"
    }
  },
  {
    "code": "KI",
    "countryCode": 686,
    "names": {
      "de": "Kiribati",
      "en": "Kiribati",
      "es": "Kiribati",
      "fi": "Kiribati",
      "fr": "Kiribati",
      "it": "Kiribati",
      "nl": "Kiribati",
      "pt": "Kiribati",
      "sv": "Kiribati"
    }
  },
  {
    "code": "KM",
    "countryCode": 269,
    "names": {
      "de": "Komoren",
      "en": "Comoros",
      "es": "Comores, Islas",
      "fi": "Komorit",
      "fr": "Comores",
      "it": "Comore",
      "nl": "Comoren",
      "pt": "Comores",
      "sv": "Comorerna"
    }
  },
  {
    "code": "KN",
    "countryCode": 1,
    "names": {
      "de": "St. Kitts und Nevis",
      "en": "Saint Kitts and Nevis",
      "es": "San Cristóbal y Nieves",
      "fi": "Saint Kitts ja Nevis",
      "fr": "Saint-Christophe-et-Niévès",
      "it": "Saint Kitts e Nevis",
      "nl": "Saint Kitts en Nevis",
      "pt": "São Cristóvão e Nevis",
      "sv": "Sankt Kitts och Nevis"
    }
  },
  {
    "code": "KP",
    "countryCode": 850,
    "names": {
      "de": "Korea, Demokratische Volksrepublik (Nordkorea)",
      "en": "Korea, Democratic People's Republic of",
      "es": "Corea, República Democrática Popular de",
      "fi": "Korean demokraattinen kansantasavalta",
      "fr": "Corée du Nord",
      "it": "Corea del Nord",
      "nl": "Korea, Democratische Volksrepubliek",
      "pt": "Coreia, República Popular Democrática da",
      "sv": "Korea, demokratiska folkrepubliken"
    }
  },
  {
    "code": "KR",
    "countryCode": 82,
    "names": {
      "de": "Korea, Republik (Südkorea)",
      "en": "South Korea",
      "es": "Corea, República de",
      "fi": "Korean tasavalta",
      "fr": "Corée du Sud",
      "it": "Corea del sud",
      "nl": "Korea, Republiek",
      "pt": "Coreia, República da",
      "sv": "Sydkorea"
    }
  },
  {
    "code": "KW",
    "countryCode": 965,
    "names": {
      "de": "Kuwait",
      "en": "Kuwait",
      "es": "Kuwait",
      "fi": "Kuwait",
      "fr": "Koweït",
      "it": "Kuwait",
      "nl": "Koeweit",
      "pt": "Kuwait",
      "sv": "Kuwait"
    }
  },
  {
    "code": "KY",
    "countryCode": 1,
    "names": {
      "de": "Kaimaninseln",
      "en": "Cayman Islands",
      "es": "Islas Caimán",
      "fi": "Caymansaaret",
      "fr": "Îles Caïmans",
      "it": "Isole Cayman",
      "nl": "Caymaneilanden",
      "pt": "Ilhas Caimão",
      "sv": "Caymanöarna"
    }
  },
  {
    "code": "KZ",
    "countryCode": 7,
    "names": {
      "de": "Kasachstan",
      "en": "Kazakhstan",
      "es": "Kazajistán",
      "fi": "Kazakstan",
      "fr": "Kazakhstan",
      "it": "Kazakistan",
      "nl": "Kazachstan",
      "pt": "Cazaquistão",
      "sv": "Kazakstan"
    }
  },
  {
    "code": "LA",
    "countryCode": 856,
    "names": {
      "de": "Laos, Demokratische Volksrepublik",
      "en": "Lao People's Democratic Republic",
      "es": "República Democrática Popular de Lao",
      "fi": "Laos",
      "fr": "Laos",
      "it": "Laos",
      "nl": "Laos",
      "pt": "República Democrática Popular do Laos",
      "sv": "Demokratiska folkrepubliken Lao"
    }
  },
  {
    "code": "LB",
    "countryCode": 961,
    "names": {
      "de": "Libanon",
      "en": "Lebanon",
      "es": "Líbano",
      "fi": "Libanon",
      "fr": "Liban",
      "it": "Libano",
      "nl": "Libanon",
      "pt": "Líbano",
      "sv": "Libanon"
    }
  },
  {
    "code": "LC",
    "countryCode": 1,
    "names": {
      "de": "St. Lucia",
      "en": "Saint Lucia",
      "es": "Santa Lucía",
      "fi": "Saint Lucia",
      "fr": "Sainte-Lucie",
      "it": "Saint Lucia",
      "nl": "Saint Lucia",
      "pt": "Santa Lúcia",
      "sv": "Sankt Lucia"
    }
  },
  {
    "code": "LI",
    "countryCode": 423,
    "names": {
      "de": "Liechtenstein",
      "en": "Liechtenstein",
      "es": "Liechtenstein",
      "fi": "Liechtenstein",
      "fr": "Liechtenstein",
      "it": "Liechtenstein",
      "nl": "Liechtenstein",
      "pt": "Liechtenstein",
      "sv": "Liechtenstein"
    }
  },
  {
    "code": "LK",
    "countryCode": 94,
    "names": {
      "de": "Sri Lanka",
      "en": "Sri Lanka",
      "es": "Sri Lanka",
      "fi": "Sri Lanka",
      "fr": "Sri Lanka",
      "it": "Sri Lanka",
      "nl": "Sri Lanka",
      "pt": "Sri Lanka",
      "sv": "Sri Lanka"
    }
  },
  {
    "code": "LR",
    "countryCode": 231,
    "names": {
      "de": "Liberia",
      "en": "Liberia",
      "es": "Liberia",
      "fi": "Liberia",
      "fr": "Liberia",
      "it": "Liberia",
      "nl": "Liberia",
      "pt": "Libéria",
      "sv": "Liberia"
    }
  },
  {
    "code": "LS",
    "countryCode": 266,
    "names": {
      "de": "Lesotho",
      "en": "Lesotho",
      "es": "Lesoto",
      "fi": "Lesotho",
      "fr": "Lesotho",
      "it": "Lesotho",
      "nl": "Lesotho",
      "pt": "Lesoto",
      "sv": "Lesotho"
    }
  },
  {
    "code": "LT",
    "countryCode": 370,
    "names": {
      "de": "Litauen",
      "en": "Lithuania",
      "es": "Lituania",
      "fi": "Liettua",
      "fr": "Lituanie",
      "it": "Lituania",
      "nl": "Litouwen",
      "pt": "Lituânia",
      "sv": "Litauen"
    }
  },
  {
    "code": "LU",
    "countryCode": 352,
    "names": {
      "de": "Luxemburg",
      "en": "Luxembourg",
      "es": "Luxemburgo",
      "fi": "Luxemburg",
      "fr": "Luxembourg",
      "it": "Lussemburgo",
      "nl": "Luxemburg",
      "pt": "Luxemburgo",
      "sv": "Luxemburg"
    }
  },
  {
    "code": "LV",
    "countryCode": 371,
    "names": {
      "de": "Lettland",
      "en": "Latvia",
      "es": "Letonia",
      "fi": "Latvia",
      "fr": "Lettonie",
      "it": "Lettonia",
      "nl": "Letland",
      "pt": "Letónia",
      "sv": "Lettland"
    }
  },
  {
    "code": "LY",
    "countryCode": 218,
    "names": {
      "de": "Libysch-Arabische Dschamahirija (Libyen)",
      "en": "Libya",
      "es": "Libia",
      "fi": "Libya",
      "fr": "Libye",
      "it": "Libia",
      "nl": "Libië",
      "pt": "Líbia",
      "sv": "Libyen"
    }
  },
  {
    "code": "MA",
    "countryCode": 212,
    "names": {
      "de": "Marokko",
      "en": "Morocco",
      "es": "Marruecos",
      "fi": "Marokko",
      "fr": "Maroc",
      "it": "Marocco",
      "nl": "Marokko",
      "pt": "Marrocos",
      "sv": "Marocko"
    }
  },
  {
    "code": "MC",
    "countryCode": 377,
    "names": {
      "de": "Monaco",
      "en": "Monaco",
      "es": "Mónaco",
      "fi": "Monaco",
      "fr": "Monaco",
      "it": "Monaco",
      "nl": "Monaco",
      "pt": "Mónaco",
      "sv": "Monaco"
    }
  },
  {
    "code": "MD",
    "countryCode": 373,
    "names": {
      "de": "Moldawien (Republik Moldau)",
      "en": "Moldova, Republic of",
      "es": "Moldavia, República de",
      "fi": "Moldovan tasavalta",
      "fr": "Moldovie",
      "it": "Moldavia",
      "nl": "Moldavië",
      "pt": "Moldávia, República da",
      "sv": "Moldavien, republiken"
    }
  },
  {
    "code": "ME",
    "countryCode": 382,
    "names": {
      "de": "Montenegro",
      "en": "Montenegro",
      "es": "Montenegro",
      "fi": "Montenegro",
      "fr": "Monténégro",
      "it": "Montenegro",
      "nl": "Montenegro",
      "pt": "Montenegro",
      "sv": "Montenegro"
    }
  },
  {
    "code": "MF",
    "countryCode": 590,
    "names": {
      "de": "Saint-Martin (franz. Teil)",
      "en": "Saint Martin (French part)",
      "es": "San Martín (zona francesa)",
      "fi": "Saint-Martin (ranskalainen osa)",
      "fr": "Saint-Martin (Antilles françaises)",
      "it": "Saint-Martin (Francia)",
      "nl": "Sint-Maarten (Frans deel)",
      "pt": "São Martin (Território Francês)",
      "sv": "Saint Martin (franska delen)"
    }
  },
  {
    "code": "MG",
    "countryCode": 261,
    "names": {
      "de": "Madagaskar",
      "en": "Madagascar",
      "es": "Madagascar",
      "fi": "Madagaskar",
      "fr": "Malgache",
      "it": "Madagascar",
      "nl": "Madagaskar",
      "pt": "Madagáscar",
      "sv": "Madagaskar"
    }
  },
  {
    "code": "MH",
    "countryCode": 692,
    "names": {
      "de": "Marshallinseln",
      "en": "Marshall Islands",
      "es": "Islas Marshall",
      "fi": "Marshallinsaaret",
      "fr": "Îles Marshall",
      "it": "Isole Marshall",
      "nl": "Marshalleilanden",
      "pt": "Ilhas Marshall",
      "sv": "Marshallöarna"
    }
  },
  {
    "code": "MK",
    "countryCode": 389,
    "names": {
      "de": "Nordmazedonien",
      "en": "North Macedonia",
      "es": "Macedonia del Norte",
      "fi": "Pohjois-Makedonia",
      "fr": "Macédoine du Nord",
      "it": "Macedonia del Nord",
      "nl": "Noord-Macedonië",
      "pt": "Macedónia do Norte",
      "sv": "Nordmakedonien"
    }
  },
  {
    "code": "ML",
    "countryCode": 223,
    "names": {
      "de": "Mali",
      "en": "Mali",
      "es": "Malí",
      "fi": "Mali",
      "fr": "Mali",
      "it": "Mali",
      "nl": "Mali",
      "pt": "Mali",
      "sv": "Mali"
    }
  },
  {
    "code": "MM",
    "countryCode": 95,
    "names": {
      "de": "Myanmar (Burma)",
      "en": "Myanmar",
      "es": "Birmania",
      "fi": "Myanmar",
      "fr": "Myanmar",
      "it": "Birmania",
      "nl": "Myanmar",
      "pt": "Birmânia",
      "sv": "Myanmar"
    }
  },
  {
    "code": "MN",
    "countryCode": 976,
    "names": {
      "de": "Mongolei",
      "en": "Mongolia",
      "es": "Mongolia",
      "fi": "Mongolia",
      "fr": "Mongolie",
      "it": "Mongolia",
      "nl": "Mongolië",
      "pt": "Mongólia",
      "sv": "Mongoliet"
    }
  },
  {
    "code": "MO",
    "countryCode": 853,
    "names": {
      "de": "Macao",
      "en": "Macao",
      "es": "Macao",
      "fi": "Macao",
      "fr": "Macao",
      "it": "Macao",
      "nl": "Macao",
      "pt": "Macau",
      "sv": "Macao"
    }
  },
  {
    "code": "MP",
    "countryCode": 1,
    "names": {
      "de": "Nördliche Marianen",
      "en": "Northern Mariana Islands",
      "es": "Islas Marianas del Norte",
      "fi": "Pohjois-Mariaanit",
      "fr": "Îles Mariannes du Nord",
      "it": "Isole Marianne Settentrionali",
      "nl": "Noordelijke Marianeneilanden",
      "pt": "Ilhas Marianas do Norte",
      "sv": "Nordmarianerna"
    }
  },
  {
    "code": "MQ",
    "countryCode": 596,
    "names": {
      "de": "Martinique",
      "en": "Martinique",
      "es": "Martinica",
      "fi": "Martinique",
      "fr": "Martinique",
      "it": "Martinica",
      "nl": "Martinique",
      "pt": "Martinica",
      "sv": "Martinique"
    }
  },
  {
    "code": "MR",
    "countryCode": 222,
    "names": {
      "de": "Mauretanien",
      "en": "Mauritania",
      "es": "Mauritania",
      "fi": "Mauritania",
      "fr": "Mauritanie",
      "it": "Mauritania",
      "nl": "Mauritanië",
      "pt": "Mauritânia",
      "sv": "Mauretanien"
    }
  },
  {
    "code": "MS",
    "countryCode": 1,
    "names": {
      "de": "Montserrat",
      "en": "Montserrat",
      "es": "Montserrat",
      "fi": "Montserrat",
      "fr": "Montserrat (Antilles)",
      "it": "Montserrat",
      "nl": "Montserrat",
      "pt": "Monserrate",
      "sv": "Montserrat"
    }
  },
  {
    "code": "MT",
    "countryCode": 356,
    "names": {
      "de": "Malta",
      "en": "Malta",
      "es": "Malta",
      "fi": "Malta",
      "fr": "Malte",
      "it": "Malta",
      "nl": "Malta",
      "pt": "Malta",
      "sv": "Malta"
    }
  },
  {
    "code": "MU",
    "countryCode": 230,
    "names": {
      "de": "Mauritius",
      "en": "Mauritius",
      "es": "Mauricio",
      "fi": "Mauritius",
      "fr": "Maurice",
      "it": "Maurizio",
      "nl": "Mauritius",
      "pt": "Maurícia",
      "sv": "Mauritius"
    }
  },
  {
    "code": "MV",
    "countryCode": 960,
    "names": {
      "de": "Malediven",
      "en": "Maldives",
      "es": "Islas Maldivas",
      "fi": "Malediivit",
      "fr": "Maldives",
      "it": "Maldive",
      "nl": "Maldiven",
      "pt": "Maldivas",
      "sv": "Maldiverna"
    }
  },
  {
    "code": "MW",
    "countryCode": 265,
    "names": {
      "de": "Malawi",
      "en": "Malawi",
      "es": "Malaui",
      "fi": "Malawi",
      "fr": "Malawi",
      "it": "Malawi",
      "nl": "Malawi",
      "pt": "Malawi",
      "sv": "Malawi"
    }
  },
  {
    "code": "MX",
    "countryCode": 52,
    "names": {
      "de": "Mexiko",
      "en": "Mexico",
      "es": "México",
      "fi": "Meksiko",
      "fr": "Mexique",
      "it": "Messico",
      "nl": "Mexico",
      "pt": "México",
      "sv": "Mexiko"
    }
  },
  {
    "code": "MY",
    "countryCode": 60,
    "names": {
      "de": "Malaysia",
      "en": "Malaysia",
      "es": "Malasia",
      "fi": "Malesia",
      "fr": "Malaisie",
      "it": "Malaysia",
      "nl": "Maleisië",
      "pt": "Malásia",
      "sv": "Malaysia"
    }
  },
  {
    "code": "MZ",
    "countryCode": 258,
    "names": {
      "de": "Mosambik",
      "en": "Mozambique",
      "es": "Mozambique",
      "fi": "Mosambik",
      "fr": "Mozambique",
      "it": "Mozambico",
      "nl": "Mozambique",
      "pt": "Moçambique",
      "sv": "Moçambique"
    }
  },
  {
    "code": "NA",
    "countryCode": 264,
    "names": {
      "de": "Namibia",
      "en": "Namibia",
      "es": "Namibia",
      "fi": "Namibia",
      "fr": "Namibie",
      "it": "Namibia",
      "nl": "Namibië",
      "pt": "Namíbia",
      "sv": "Namibia"
    }
  },
  {
    "code": "NC",
    "countryCode": 687,
    "names": {
      "de": "Neukaledonien",
      "en": "New Caledonia",
      "es": "Nueva Caledonia",
      "fi": "Uusi-Kaledonia",
      "fr": "Nouvelle-Calédonie",
      "it": "Nuova Caledonia",
      "nl": "Nieuw-Caledonië",
      "pt": "Nova Caledónia",
      "sv": "Nya Kaledonien"
    }
  },
  {
    "code": "NE",
    "countryCode": 227,
    "names": {
      "de": "Niger",
      "en": "Niger",
      "es": "Niger",
      "fi": "Niger",
      "fr": "Niger",
      "it": "Niger",
      "nl": "Niger",
      "pt": "Níger",
      "sv": "Niger"
    }
  },
  {
    "code": "NF",
    "countryCode": 672,
    "names": {
      "de": "Norfolkinsel",
      "en": "Norfolk Island",
      "es": "Isla Norfolk",
      "fi": "Norfolkinsaari",
      "fr": "Île Norfolk",
      "it": "Isola Norfolk",
      "nl": "Norfolkeiland",
      "pt": "Ilha Norfolk",
      "sv": "Norfolköarna"
    }
  },
  {
    "code": "NG",
    "countryCode": 234,
    "names": {
      "de": "Nigeria",
      "en": "Nigeria",
      "es": "Nigeria",
      "fi": "Nigeria",
      "fr": "Nigeria",
      "it": "Nigeria",
      "nl": "Nigeria",
      "pt": "Nigéria",
      "sv": "Nigeria"
    }
  },
  {
    "code": "NI",
    "countryCode": 505,
    "names": {
      "de": "Nicaragua",
      "en": "Nicaragua",
      "es": "Nicaragua",
      "fi": "Nicaragua",
      "fr": "Nicaragua",
      "it": "Nicaragua",
      "nl": "Nicaragua",
      "pt": "Nicarágua",
      "sv": "Nicaragua"
    }
  },
  {
    "code": "NL",
    "countryCode": 31,
    "names": {
      "de": "Niederlande",
      "en": "Netherlands",
      "es": "Países Bajos",
      "fi": "Alankomaat",
      "fr": "Pays-Bas",
      "it": "Paesi Bassi",
      "nl": "Nederland",
      "pt": "Países Baixos",
      "sv": "Nederländerna"
    }
  },
  {
    "code": "NO",
    "countryCode": 47,
    "names": {
      "de": "Norwegen",
      "en": "Norway",
      "es": "Noruega",
      "fi": "Norja",
      "fr": "Norvège",
      "it": "Norvegia",
      "nl": "Noorwegen",
      "pt": "Noruega",
      "sv": "Norge"
    }
  },
  {
    "code": "NP",
    "countryCode": 977,
    "names": {
      "de": "Nepal",
      "en": "Nepal",
      "es": "Nepal",
      "fi": "Nepal",
      "fr": "Népal",
      "it": "Nepal",
      "nl": "Nepal",
      "pt": "Nepal",
      "sv": "Nepal"
    }
  },
  {
    "code": "NR",
    "countryCode": 674,
    "names": {
      "de": "Nauru",
      "en": "Nauru",
      "es": "Nauru",
      "fi": "Nauru",
      "fr": "Nauru",
      "it": "Nauru",
      "nl": "Nauru",
      "pt": "Nauru",
      "sv": "Nauru"
    }
  },
  {
    "code": "NU",
    "countryCode": 683,
    "names": {
      "de": "Niue",
      "en": "Niue",
      "es": "Niue",
      "fi": "Niue",
      "fr": "Niue",
      "it": "Niue",
      "nl": "Niue",
      "pt": "Niue",
      "sv": "Niue"
    }
  },
  {
    "code": "NZ",
    "countryCode": 64,
    "names": {
      "de": "Neuseeland",
      "en": "New Zealand",
      "es": "Nueva Zelanda",
      "fi": "Uusi-Seelanti",
      "fr": "Nouvelle-Zélande",
      "it": "Nuova Zelanda",
      "nl": "Nieuw-Zeeland",
      "pt": "Nova Zelândia",
      "sv": "Nya Zeeland"
    }
  },
  {
    "code": "OM",
    "countryCode": 968,
    "names": {
      "de": "Oman",
      "en": "Oman",
      "es": "Omán",
      "fi": "Oman",
      "fr": "Oman",
      "it": "Oman",
      "nl": "Oman",
      "pt": "Omã",
      "sv": "Oman"
    }
  },
  {
    "code": "PA",
    "countryCode": 507,
    "names": {
      "de": "Panama",
      "en": "Panama",
      "es": "Panamá",
      "fi": "Panama",
      "fr": "Panama",
      "it": "Panama",
      "nl": "Panama",
      "pt": "Panamá",
      "sv": "Panama"
    }
  },
  {
    "code": "PE",
    "countryCode": 51,
    "names": {
      "de": "Peru",
      "en": "Peru",
      "es": "Perú",
      "fi": "Peru",
      "fr": "Pérou",
      "it": "Perù",
      "nl": "Peru",
      "pt": "Peru",
      "sv": "Peru"
    }
  },
  {
    "code": "PF",
    "countryCode": 689,
    "names": {
      "de": "Französisch-Polynesien",
      "en": "French Polynesia",
      "es": "Polinesia Francesa",
      "fi": "Ranskan Polynesia",
      "fr": "Polynésie française",
      "it": "Polinesia francese",
      "nl": "Frans-Polynesië",
      "pt": "Polinésia Francesa",
      "sv": "Franska Polynesien"
    }
  },
  {
    "code": "PG",
    "countryCode": 675,
    "names": {
      "de": "Papua-Neuguinea",
      "en": "Papua New Guinea",
      "es": "Papúa Nueva Guinea",
      "fi": "Papua-Uusi-Guinea",
      "fr": "Papouasie-Nouvelle-Guinée",
      "it": "Papua Nuova Guinea",
      "nl": "Papoea-Nieuw-Guinea",
      "pt": "Papua Nova Guiné",
      "sv": "Papua Nya Guinea"
    }
  },
  {
    "code": "PH",
    "countryCode": 63,
    "names": {
      "de": "Philippinen",
      "en": "Philippines",
      "es": "Filipinas",
      "fi": "Filippiinit",
      "fr": "Philippines",
      "it": "Filippine",
      "nl": "Filipijnen",
      "pt": "Filipinas",
      "sv": "Filippinerna"
    }
  },
  {
    "code": "PK",
    "countryCode": 92,
    "names": {
      "de": "Pakistan",
      "en": "Pakistan",
      "es": "Pakistán",
      "fi": "Pakistan",
      "fr": "Pakistan",
      "it": "Pakistan",
      "nl": "Pakistan",
      "pt": "Paquistão",
      "sv": "Pakistan"
    }
  },
  {
    "code": "PL",
    "countryCode": 48,
    "names": {
      "de": "Polen",
      "en": "Poland",
      "es": "Polonia",
      "fi": "Puola",
      "fr": "Pologne",
      "it": "Polonia",
      "nl": "Polen",
      "pt": "Polónia",
      "sv": "Polen"
    }
  },
  {
    "code": "PM",
    "countryCode": 508,
    "names": {
      "de": "Saint-Pierre und Miquelon",
      "en": "Saint Pierre and Miquelon",
      "es": "San Pedro y Miquelon",
      "fi": "Saint-Pierre ja Miquelon",
      "fr": "Saint-Pierre-et-Miquelon",
      "it": "Saint-Pierre e Miquelon",
      "nl": "Saint Pierre en Miquelon",
      "pt": "Saint Pierre e Miquelon",
      "sv": "Sankt Pierre och Miquelon"
    }
  },
  {
    "code": "PN",
    "countryCode": 0,
    "names": {
      "de": "Pitcairninseln",
      "en": "Pitcairn",
      "es": "Pitcairn",
      "fi": "Pitcairn",
      "fr": "Île Pitcairn",
      "it": "Pitcairn",
      "nl": "Pitcairn",
      "pt": "Pitcairn",
      "sv": "Pitcairn"
    }
  },
  {
    "code": "PR",
    "countryCode": 1,
    "names": {
      "de": "Puerto Rico",
      "en": "Puerto Rico",
      "es": "Puerto Rico",
      "fi": "Puerto Rico",
      "fr": "Porto Rico",
      "it": "Portorico",
      "nl": "Puerto Rico",
      "pt": "Porto Rico",
      "sv": "Puerto Rico"
    }
  },
  {
    "code": "PS",
    "countryCode": 970,
    "names": {
      "de": "Palästinensische Autonomiegebiete",
      "en": "Palestine, State of",
      "es": "Palestina, Estado de",
      "fi": "Palestine, State of",
      "fr": "Territoires Palestiniens",
      "it": "Palestina, Stato di",
      "nl": "Palestijns Gebied",
      "pt": "Palestina, Estado da",
      "sv": "Staten Palestina"
    }
  },
  {
    "code": "PT",
    "countryCode": 351,
    "names": {
      "de": "Portugal",
      "en": "Portugal",
      "es": "Portugal",
      "fi": "Portugali",
      "fr": "Portugal",
      "it": "Portogallo",
      "nl": "Portugal",
      "pt": "Portugal",
      "sv": "Portugal"
    }
  },
  {
    "code": "PW",
    "countryCode": 680,
    "names": {
      "de": "Palau",
      "en": "Palau",
      "es": "Palaos",
      "fi": "Palau",
      "fr": "Palaos",
      "it": "Palau",
      "nl": "Palau",
      "pt": "Palau",
      "sv": "Palau"
    }
  },
  {
    "code": "PY",
    "countryCode": 595,
    "names": {
      "de": "Paraguay",
      "en": "Paraguay",
      "es": "Paraguay",
      "fi": "Paraguay",
      "fr": "Paraguay",
      "it": "Paraguay",
      "nl": "Paraguay",
      "pt": "Paraguai",
      "sv": "Paraguay"
    }
  },
  {
    "code": "QA",
    "countryCode": 974,
    "names": {
      "de": "Katar",
      "en": "Qatar",
      "es": "Catar",
      "fi": "Qatar",
      "fr": "Qatar",
      "it": "Qatar",
      "nl": "Qatar",
      "pt": "Catar",
      "sv": "Qatar"
    }
  },
  {
    "code": "RE",
    "countryCode": 262,
    "names": {
      "de": "Réunion",
      "en": "Réunion",
      "es": "Reunión",
      "fi": "Réunion",
      "fr": "La Réunion",
      "it": "Riunione",
      "nl": "Réunion",
      "pt": "Ilha Reunião",
      "sv": "Réunion"
    }
  },
  {
    "code": "RO",
    "countryCode": 40,
    "names": {
      "de": "Rumänien",
      "en": "Romania",
      "es": "Rumanía",
      "fi": "Romania",
      "fr": "Roumanie",
      "it": "Romania",
      "nl": "Roemenië",
      "pt": "Roménia",
      "sv": "Rumänien"
    }
  },
  {
    "code": "RS",
    "countryCode": 381,
    "names": {
      "de": "Serbien",
      "en": "Serbia",
      "es": "Serbia",
      "fi": "Serbia",
      "fr": "Serbie",
      "it": "Serbia",
      "nl": "Servië",
      "pt": "Sérvia",
      "sv": "Serbien"
    }
  },
  {
    "code": "RU",
    "countryCode": 7,
    "names": {
      "de": "Russische Föderation",
      "en": "Russia",
      "es": "Federación Rusa",
      "fi": "Venäjän federaatio",
      "fr": "Russie",
      "it": "Russia",
      "nl": "Rusland",
      "pt": "Federação Russa",
      "sv": "Ryska federationen"
    }
  },
  {
    "code": "RW",
    "countryCode": 250,
    "names": {
      "de": "Ruanda",
      "en": "Rwanda",
      "es": "Ruanda",
      "fi": "Ruanda",
      "fr": "Rwanda",
      "it": "Ruanda",
      "nl": "Rwanda",
      "pt": "Ruanda",
      "sv": "Rwanda"
    }
  },
  {
    "code": "SA",
    "countryCode": 966,
    "names": {
      "de": "Saudi-Arabien",
      "en": "Saudi Arabia",
      "es": "Arabia Saudí",
      "fi": "Saudi-Arabia",
      "fr": "Arabie saoudite",
      "it": "Arabia Saudita",
      "nl": "Saoedi-Arabië",
      "pt": "Arábia Saudita",
      "sv": "Saudiarabien"
    }
  },
  {
    "code": "SB",
    "countryCode": 677,
    "names": {
      "de": "Salomonen",
      "en": "Solomon Islands",
      "es": "Islas Salomón",
      "fi": "Salomonsaaret",
      "fr": "Îles Salomon",
      "it": "Isole Salomone",
      "nl": "Salomonseilanden",
      "pt": "Ilhas Salomão",
      "sv": "Salomonöarna"
    }
  },
  {
    "code": "SC",
    "countryCode": 248,
    "names": {
      "de": "Seychellen",
      "en": "Seychelles",
      "es": "Seychelles",
      "fi": "Seychellit",
      "fr": "Seychelles",
      "it": "Seychelles",
      "nl": "Seychellen",
      "pt": "Seychelles",
      "sv": "Seychellerna"
    }
  },
  {
    "code": "SD",
    "countryCode": 249,
    "names": {
      "de": "Sudan",
      "en": "Sudan",
      "es": "Sudán",
      "fi": "Sudan",
      "fr": "Soudan",
      "it": "Sudan",
      "nl": "Soedan",
      "pt": "Sudão",
      "sv": "Sudan"
    }
  },
  {
    "code": "SE",
    "countryCode": 46,
    "names": {
      "de": "Schweden",
      "en": "Sweden",
      "es": "Suecia",
      "fi": "Ruotsi",
      "fr": "Suède",
      "it": "Svezia",
      "nl": "Zweden",
      "pt": "Suécia",
      "sv": "Sverige"
    }
  },
  {
    "code": "SG",
    "countryCode": 65,
    "names": {
      "de": "Singapur",
      "en": "Singapore",
      "es": "Singapur",
      "fi": "Singapore",
      "fr": "Singapour",
      "it": "Singapore",
      "nl": "Singapore",
      "pt": "Singapura",
      "sv": "Singapore"
    }
  },
  {
    "code": "SH",
    "countryCode": 290,
    "names": {
      "de": "St. Helena",
      "en": "Saint Helena, Ascension and Tristan da Cunha",
      "es": "Santa Elena, Ascensión y Tristán de Acuña",
      "fi": "Saint Helena, Ascension ja Tristan da Cunha",
      "fr": "Sainte-Hélène, Ascension et Tristan da Cunha",
      "it": "Sant'Elena, Ascensione e Tristan da Cunha",
      "nl": "Sint-Helena",
      "pt": "Santa Helena, Ascensão e Tristão da Cunha",
      "sv": "Saint Helena, Ascension och Tristan da Cunha"
    }
  },
  {
    "code": "SI",
    "countryCode": 386,
    "names": {
      "de": "Slowenien",
      "en": "Slovenia",
      "es": "Eslovenia",
      "fi": "Slovenia",
      "fr": "Slovénie",
      "it": "Slovenia",
      "nl": "Slovenië",
      "pt": "Eslovénia",
      "sv": "Slovenien"
    }
  },
  {
    "code": "SJ",
    "countryCode": 47,
    "names": {
      "de": "Svalbard und Jan Mayen",
      "en": "Svalbard and Jan Mayen",
      "es": "Svalbard y Jan Mayen",
      "fi": "Svalbard ja Jan Mayen",
      "fr": "Svalbard et Jan Mayen",
      "it": "Svalbard e Jan Mayen",
      "nl": "Svalbard en Jan Mayen",
      "pt": "Svalbard e Jan Mayen",
      "sv": "Svalbard och Jan Mayen"
    }
  },
  {
    "code": "SK",
    "countryCode": 421,
    "names": {
      "de": "Slowakei",
      "en": "Slovakia",
      "es": "Eslovaquia",
      "fi": "Slovakia",
      "fr": "Slovaquie",
      "it": "Slovacchia",
      "nl": "Slowakije",
      "pt": "Eslováquia",
      "sv": "Slovakien"
    }
  },
  {
    "code": "SL",
    "countryCode": 232,
    "names": {
      "de": "Sierra Leone",
      "en": "Sierra Leone",
      "es": "Sierra Leona",
      "fi": "Sierra Leone",
      "fr": "Sierra Leone",
      "it": "Sierra Leone",
      "nl": "Sierra Leone",
      "pt": "Serra Leoa",
      "sv": "Sierra Leone"
    }
  },
  {
    "code": "SM",
    "countryCode": 378,
    "names": {
      "de": "San Marino",
      "en": "San Marino",
      "es": "San Marino",
      "fi": "San Marino",
      "fr": "Saint-Marin",
      "it": "San Marino",
      "nl": "San Marino",
      "pt": "San Marino",
      "sv": "San Marino"
    }
  },
  {
    "code": "SN",
    "countryCode": 221,
    "names": {
      "de": "Senegal",
      "en": "Senegal",
      "es": "Senegal",
      "fi": "Senegal",
      "fr": "Sénégal",
      "it": "Senegal",
      "nl": "Senegal",
      "pt": "Senegal",
      "sv": "Senegal"
    }
  },
  {
    "code": "SO",
    "countryCode": 252,
    "names": {
      "de": "Somalia",
      "en": "Somalia",
      "es": "Somalia",
      "fi": "Somalia",
      "fr": "Somalie",
      "it": "Somalia",
      "nl": "Somalië",
      "pt": "Somália",
      "sv": "Somalia"
    }
  },
  {
    "code": "SR",
    "countryCode": 597,
    "names": {
      "de": "Suriname",
      "en": "Suriname",
      "es": "Surinám",
      "fi": "Suriname",
      "fr": "Suriname",
      "it": "Suriname",
      "nl": "Suriname",
      "pt": "Suriname",
      "sv": "Surinam"
    }
  },
  {
    "code": "SS",
    "countryCode": 211,
    "names": {
      "de": "Südsudan",
      "en": "South Sudan",
      "es": "Sudán del Sur",
      "fi": "Etelä-Sudan",
      "fr": "Soudan du Sud",
      "it": "Sudan del sud",
      "nl": "Zuid-Soedan",
      "pt": "Sudão do Sul",
      "sv": "Sydsudan"
    }
  },
  {
    "code": "ST",
    "countryCode": 239,
    "names": {
      "de": "São Tomé und Príncipe",
      "en": "Sao Tome and Principe",
      "es": "Santo Tomé y Príncipe",
      "fi": "São Tomé ja Príncipe",
      "fr": "Sao Tomé-et-Principe",
      "it": "São Tomé e Príncipe",
      "nl": "Sao Tomé en Principe",
      "pt": "São Tomé e Príncipe",
      "sv": "São Tomé och Príncipe"
    }
  },
  {
    "code": "SV",
    "countryCode": 503,
    "names": {
      "de": "El Salvador",
      "en": "El Salvador",
      "es": "El Salvador",
      "fi": "El Salvador",
      "fr": "Salvador",
      "it": "El Salvador",
      "nl": "El Salvador",
      "pt": "El Salvador",
      "sv": "El Salvador"
    }
  },
  {
    "code": "SX",
    "countryCode": 1,
    "names": {
      "de": "Sint Maarten",
      "en": "Sint Maarten (Dutch part)",
      "es": "Isla de San Martín (zona holandsea)",
      "fi": "Sint Maarten (hollantilainen osa)",
      "fr": "Saint-Martin (Royaume des Pays-Bas)",
      "it": "Sint Maarten (Olanda)",
      "nl": "Sint Maarten (Nederlands deel)",
      "pt": "São Martinho (Países Baixos)",
      "sv": "Sint Maarten (nederländska delen)"
    }
  },
  {
    "code": "SY",
    "countryCode": 963,
    "names": {
      "de": "Syrien, Arabische Republik",
      "en": "Syrian Arab Republic",
      "es": "República árabe de Siria",
      "fi": "Syyrian arabitasavalta",
      "fr": "Syrie",
      "it": "Siria",
      "nl": "Syrië",
      "pt": "República Árabe Síria",
      "sv": "Syriska arabrepubliken"
    }
  },
  {
    "code": "SZ",
    "countryCode": 268,
    "names": {
      "de": "Swasiland",
      "en": "Swaziland",
      "es": "Esuatini",
      "fi": "Swaziland",
      "fr": "Swaziland",
      "it": "Swaziland",
      "nl": "Swaziland",
      "pt": "Suazilândia",
      "sv": "Swaziland"
    }
  },
  {
    "code": "TC",
    "countryCode": 1,
    "names": {
      "de": "Turks- und Caicosinseln",
      "en": "Turks and Caicos Islands",
      "es": "Islas Turcas y Caicos",
      "fi": "Turks- ja Caicossaaret",
      "fr": "Îles Turques-et-Caïques",
      "it": "Isole Turks e Caicos",
      "nl": "Turks- en Caicoseilanden",
      "pt": "Ilhas Turcas e Caicos",
      "sv": "Turks- och Caicosöarna"
    }
  },
  {
    "code": "TD",
    "countryCode": 235,
    "names": {
      "de": "Tschad",
      "en": "Chad",
      "es": "Chad",
      "fi": "Tšad",
      "fr": "Tchad",
      "it": "Ciad",
      "nl": "Tsjaad",
      "pt": "Chade",
      "sv": "Tchad"
    }
  },
  {
    "code": "TF",
    "countryCode": 0,
    "names": {
      "de": "Französische Süd- und Antarktisgebiete",
      "en": "French Southern Territories",
      "es": "Territorios Franceses del Sur",
      "fi": "Ranskan eteläiset alueet",
      "fr": "Terres australes et antarctiques françaises",
      "it": "Territori francesi meridionali",
      "nl": "Franse Gebieden in de zuidelijke Indische Oceaan",
      "pt": "Territórios Franceses do Sul",
      "sv": "Franska sydterritorierna"
    }
  },
  {
    "code": "TG",
    "countryCode": 228,
    "names": {
      "de": "Togo",
      "en": "Togo",
      "es": "Togo",
      "fi": "Togo",
      "fr": "Togo",
      "it": "Togo",
      "nl": "Togo",
      "pt": "Togo",
      "sv": "Togo"
    }
  },
  {
    "code": "TH",
    "countryCode": 66,
    "names": {
      "de": "Thailand",
      "en": "Thailand",
      "es": "Tailandia",
      "fi": "Thaimaa",
      "fr": "Thaïlande",
      "it": "Thailandia",
      "nl": "Thailand",
      "pt": "Tailândia",
      "sv": "Thailand"
    }
  },
  {
    "code": "TJ",
    "countryCode": 992,
    "names": {
      "de": "Tadschikistan",
      "en": "Tajikistan",
      "es": "Tayikistán",
      "fi": "Tadžikistan",
      "fr": "Tadjikistan",
      "it": "Tagikistan",
      "nl": "Tadzjikistan",
      "pt": "Tajiquistão",
      "sv": "Tadzjikistan"
    }
  },
  {
    "code": "TK",
    "countryCode": 690,
    "names": {
      "de": "Tokelau",
      "en": "Tokelau",
      "es": "Tokelau",
      "fi": "Tokelau",
      "fr": "Tokelau",
      "it": "Tokelau",
      "nl": "Tokelau",
      "pt": "Tokelau",
      "sv": "Tokelau"
    }
  },
  {
    "code": "TL",
    "countryCode": 670,
    "names": {
      "de": "Osttimor (Timor-Leste)",
      "en": "Timor-Leste",
      "es": "Timor Oriental",
      "fi": "Itä-Timor",
      "fr": "Timor-Oriental",
      "it": "Timor Est",
      "nl": "Oost-Timor",
      "pt": "Timor-Leste",
      "sv": "Östtimor"
    }
  },
  {
    "code": "TM",
    "countryCode": 993,
    "names": {
      "de": "Turkmenistan",
      "en": "Turkmenistan",
      "es": "Turkmenistán",
      "fi": "Turkmenistan",
      "fr": "Turkménistan",
      "it": "Turkmenistan",
      "nl": "Turkmenistan",
      "pt": "Turquemenistão",
      "sv": "Turkmenistan"
    }
  },
  {
    "code": "TN",
    "countryCode": 216,
    "names": {
      "de": "Tunesien",
      "en": "Tunisia",
      "es": "Tunez",
      "fi": "Tunisia",
      "fr": "Tunisie",
      "it": "Tunisia",
      "nl": "Tunesië",
      "pt": "Tunísia",
      "sv": "Tunisien"
    }
  },
  {
    "code": "TO",
    "countryCode": 676,
    "names": {
      "de": "Tonga",
      "en": "Tonga",
      "es": "Tonga",
      "fi": "Tonga",
      "fr": "Tonga",
      "it": "Tonga",
      "nl": "Tonga",
      "pt": "Tonga",
      "sv": "Tonga"
    }
  },
  {
    "code": "TR",
    "countryCode": 90,
    "names": {
      "de": "Türkei",
      "en": "Türkiye",
      "es": "Turquía",
      "fi": "Turkki",
      "fr": "Turquie",
      "it": "Turchia",
      "nl": "Turkije",
      "pt": "Turquia",
      "sv": "Turkiet"
    }
  },
  {
    "code": "TT",
    "countryCode": 1,
    "names": {
      "de": "Trinidad und Tobago",
      "en": "Trinidad and Tobago",
      "es": "Trinidad y Tobago",
      "fi": "Trinidad ja Tobago",
      "fr": "Trinité-et-Tobago",
      "it": "Trinidad e Tobago",
      "nl": "Trinidad en Tobago",
      "pt": "Trindade e Tobago",
      "sv": "Trinidad och Tobago"
    }
  },
  {
    "code": "TV",
    "countryCode": 688,
    "names": {
      "de": "Tuvalu",
      "en": "Tuvalu",
      "es": "Tuvalu",
      "fi": "Tuvalu",
      "fr": "Tuvalu",
      "it": "Tuvalu",
      "nl": "Tuvalu",
      "pt": "Tuvalu",
      "sv": "Tuvalu"
    }
  },
  {
    "code": "TW",
    "countryCode": 886,
    "names": {
      "de": "Taiwan",
      "en": "Taiwan",
      "es": "Taiwán, Provincia de China",
      "fi": "Taiwan, Kiinan provinssi",
      "fr": "Taïwan",
      "it": "Taiwan, Repubblica di Cina",
      "nl": "Taiwan",
      "pt": "Taiwan, Província da China",
      "sv": "Taiwan, provins i Kina"
    }
  },
  {
    "code": "TZ",
    "countryCode": 255,
    "names": {
      "de": "Tansania, Vereinigte Republik",
      "en": "Tanzania, United Republic of",
      "es": "Tanzania, República unida de",
      "fi": "Tansanian yhdistynyt tasavalta",
      "fr": "Tanzanie",
      "it": "Tanzania",
      "nl": "Tanzania",
      "pt": "Tanzânia, República Unida da",
      "sv": "Tanzania, förenade republiken"
    }
  },
  {
    "code": "UA",
    "countryCode": 380,
    "names": {
      "de": "Ukraine",
      "en": "Ukraine",
      "es": "Ucrania",
      "fi": "Ukraina",
      "fr": "Ukraine",
      "it": "Ucraina",
      "nl": "Oekraïne",
      "pt": "Ucrânia",
      "sv": "Ukraina"
    }
  },
  {
    "code": "UG",
    "countryCode": 256,
    "names": {
      "de": "Uganda",
      "en": "Uganda",
      "es": "Uganda",
      "fi": "Uganda",
      "fr": "Ouganda",
      "it": "Uganda",
      "nl": "Oeganda",
      "pt": "Uganda",
      "sv": "Uganda"
    }
  },
  {
    "code": "UM",
    "countryCode": 0,
    "names": {
      "de": "United States Minor Outlying Islands",
      "en": "United States Minor Outlying Islands",
      "es": "Islas Ultramarinas Menores de Estados Unidos",
      "fi": "Yhdysvaltain pienet erillissaaret",
      "fr": "Îles mineures éloignées des États-Unis",
      "it": "Isole minori esterne degli Stati Uniti d'America",
      "nl": "Amerikaanse kleinere afgelegen eilanden",
      "pt": "Ilhas Menores Distantes dos Estados Unidos",
      "sv": "Förenta staternas mindre öar i Oceanien och Västindien"
    }
  },
  {
    "code": "US",
    "countryCode": 1,
    "names": {
      "de": "Vereinigte Staaten von Amerika",
      "en": "United States",
      "es": "Estados Unidos",
      "fi": "Yhdysvallat",
      "fr": "États-Unis",
      "it": "Stati Uniti",
      "nl": "Verenigde Staten",
      "pt": "Estados Unidos",
      "sv": "USA"
    }
  },
  {
    "code": "UY",
    "countryCode": 598,
    "names": {
      "de": "Uruguay",
      "en": "Uruguay",
      "es": "Uruguay",
      "fi": "Uruguay",
      "fr": "Uruguay",
      "it": "Uruguay",
      "nl": "Uruguay",
      "pt": "Uruguai",
      "sv": "Uruguay"
    }
  },
  {
    "code": "UZ",
    "countryCode": 998,
    "names": {
      "de": "Usbekistan",
      "en": "Uzbekistan",
      "es": "Uzbekistán",
      "fi": "Uzbekistan",
      "fr": "Ouzbékistan",
      "it": "Uzbekistan",
      "nl": "Oezbekistan",
      "pt": "Uzbequistão",
      "sv": "Uzbekistan"
    }
  },
  {
    "code": "VA",
    "countryCode": 39,
    "names": {
      "de": "Vatikanstadt",
      "en": "Holy See (Vatican City State)",
      "es": "Santa Sede (Ciudad Estado del Vaticano)",
      "fi": "Pyhä istuin (Vatikaanivaltio)",
      "fr": "Vatican",
      "it": "Santa Sede (Stato della Città del Vaticano)",
      "nl": "Vaticaanstad, Staat",
      "pt": "Santa Sé (Estado da Cidade do Vaticano)",
      "sv": "Vatikanstaten"
    }
  },
  {
    "code": "VC",
    "countryCode": 1,
    "names": {
      "de": "St. Vincent und die Grenadinen",
      "en": "Saint Vincent and the Grenadines",
      "es": "San Vicente y las Granadinas",
      "fi": "Saint Vincent ja Grenadiinit",
      "fr": "Saint-Vincent-et-les-Grenadines",
      "it": "Saint Vincent e Grenadine",
      "nl": "Saint Vincent en de Grenadines",
      "pt": "São Vicente e Granadinas",
      "sv": "Sankt Vincent och Grenadinerna"
    }
  },
  {
    "code": "VE",
    "countryCode": 58,
    "names": {
      "de": "Venezuela",
      "en": "Venezuela, Bolivarian Republic of",
      "es": "Venezuela, República Bolivariana de",
      "fi": "Venezuelan bolivariaanien tasavalta",
      "fr": "Vénézuéla",
      "it": "Venezuela, Repubblica bolivariana del",
      "nl": "Venezuela",
      "pt": "Venezuela, República Bolivariana da",
      "sv": "Venezuela, Bolivarianska republiken"
    }
  },
  {
    "code": "VG",
    "countryCode": 1,
    "names": {
      "de": "Britische Jungferninseln",
      "en": "Virgin Islands, British",
      "es": "Islas Vírgenes, Británicas",
      "fi": "Neitsytsaaret, Brittiläiset",
      "fr": "Îles Vierges britanniques",
      "it": "Isole Vergini, Regno Unito",
      "nl": "Britse Maagdeneilanden",
      "pt": "Ilhas Virgens, Britânicas",
      "sv": "Jungfruöarna, brittiska"
    }
  },
  {
    "code": "VI",
    "countryCode": 1,
    "names": {
      "de": "Amerikanische Jungferninseln",
      "en": "Virgin Islands, U.S.",
      "es": "Islas Vírgenes, de EEUU.",
      "fi": "Neitsytsaaret, Yhdysvaltain",
      "fr": "Îles Vierges, États-Unis",
      "it": "Isole Vergini, U.S.A.",
      "nl": "Maagdeneilanden, Amerikaanse",
      "pt": "Ilhas Virgens, Estados Unidos",
      "sv": "Jungfruöarna, amerikanska"
    }
  },
  {
    "code": "VN",
    "countryCode": 84,
    "names": {
      "de": "Vietnam",
      "en": "Vietnam",
      "es": "Vietnam",
      "fi": "Vietnam",
      "fr": "Viêt Nam",
      "it": "Vietnam",
      "nl": "Vietnam",
      "pt": "Vietname",
      "sv": "Vietnam"
    }
  },
  {
    "code": "VU",
    "countryCode": 678,
    "names": {
      "de": "Vanuatu",
      "en": "Vanuatu",
      "es": "Vanuatu",
      "fi": "Vanuatu",
      "fr": "Vanuatu",
      "it": "Vanuatu",
      "nl": "Vanuatu",
      "pt": "Vanuatu",
      "sv": "Vanuatu"
    }
  },
  {
    "code": "WF",
    "countryCode": 681,
    "names": {
      "de": "Wallis und Futuna",
      "en": "Wallis and Futuna",
      "es": "Wallis y Futuna",
      "fi": "Wallis ja Futuna",
      "fr": "Wallis-et-Futuna",
      "it": "Wallis e Futuna",
      "nl": "Wallis en Futuna",
      "pt": "Wallis e Futuna",
      "sv": "Wallis och Futuna"
    }
  },
  {
    "code": "WS",
    "countryCode": 685,
    "names": {
      "de": "Samoa",
      "en": "Samoa",
      "es": "Samoa",
      "fi": "Samoa",
      "fr": "Samoa",
      "it": "Samoa",
      "nl": "Samoa",
      "pt": "Samoa",
      "sv": "Samoa"
    }
  },
  {
    "code": "XK",
    "countryCode": 383,
    "names": {
      "de": "Kosovo",
      "en": "Kosovo",
      "es": "Kosovo",
      "fi": "Kosovo",
      "fr": "Kosovo",
      "it": "Kosovo",
      "nl": "Kosovo",
      "pt": "Kosovo",
      "sv": "Kosovo"
    }
  },
  {
    "code": "YE",
    "countryCode": 967,
    "names": {
      "de": "Jemen",
      "en": "Yemen",
      "es": "Yemen",
      "fi": "Jemen",
      "fr": "Yemen",
      "it": "Yemen",
      "nl": "Jemen",
      "pt": "Iémen",
      "sv": "Yemen"
    }
  },
  {
    "code": "YT",
    "countryCode": 262,
    "names": {
      "de": "Mayotte",
      "en": "Mayotte",
      "es": "Mayotte",
      "fi": "Mayotte",
      "fr": "Mayotte",
      "it": "Mayotte",
      "nl": "Mayotte",
      "pt": "Mayotte",
      "sv": "Mayotte"
    }
  },
  {
    "code": "ZA",
    "countryCode": 27,
    "names": {
      "de": "Südafrika",
      "en": "South Africa",
      "es": "Sudáfrica",
      "fi": "Etelä-Afrikka",
      "fr": "Afrique du Sud",
      "it": "Sudafrica",
      "nl": "Zuid-Afrika",
      "pt": "África do Sul",
      "sv": "Sydafrika"
    }
  },
  {
    "code": "ZM",
    "countryCode": 260,
    "names": {
      "de": "Sambia",
      "en": "Zambia",
      "es": "Zambia",
      "fi": "Sambia",
      "fr": "Zambie",
      "it": "Zambia",
      "nl": "Zambia",
      "pt": "Zâmbia",
      "sv": "Zambia"
    }
  },
  {
    "code": "ZW",
    "countryCode": 263,
    "names": {
      "de": "Simbabwe",
      "en": "Zimbabwe",
      "es": "Zimbabue",
      "fi": "Zimbabwe",
      "fr": "Zimbabwe",
      "it": "Zimbabwe",
      "nl": "Zimbabwe",
      "pt": "Zimbábue",
      "sv": "Zimbabwe"
    }
  }
]
